import React, {Component, ReactElement} from 'react'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
import styled from 'styled-components'
import {StylesProvider} from '@mui/styles'
import {Colors, FontSize} from '../../../../styledComponents/Constants'


import {Accordion, AccordionDetails, AccordionSummary, Typography} from '@mui/material';


interface Props {
    summary: string,
    renderDetails: (targetId: string) => ReactElement
    targetId: string
}

export default class NatAccordionApartAssocComponent extends Component<Props> {

    constructor(props: Props) {
        super(props)
    }

    render(): ReactElement {

        return (
            <StylesProvider injectFirst>
                <StyledExpansionPanel>
                    <StyledExpansionPanelSummary
                        expandIcon={<ExpandMoreIcon/>}
                        aria-controls="panel1a-content"
                        id="panel1a-header"
                        style={{height: '40px', minHeight: '40px', paddingRight: '4px'}}
                    >
                        <StyledTypography>{this.props.summary}</StyledTypography>
                    </StyledExpansionPanelSummary>
                    <StyledExpansionPanelDetails>
                        {this.props.renderDetails(this.props.targetId)}
                    </StyledExpansionPanelDetails>
                </StyledExpansionPanel>
            </StylesProvider>
        )
    }
}

// 枠
const StyledExpansionPanel = styled(Accordion)`
  &.MuiAccordion-rounded:first-child {
    border-bottom-left-radius: 0;
    border-bottom-right-radius: 0;
    border-top-left-radius: 0;
    border-top-right-radius: 0;
  }
`

// 概要
const StyledExpansionPanelSummary = styled(AccordionSummary)`
  &.MuiAccordionSummary-root {
    min-height: initial;
  }

  & .MuiAccordionSummary-content {
    margin: 0;
  }

  & .MuiIconButton-root {
    color: ${Colors.PrimaryVariant};
    padding: 0;
  }

  & .MuiSvgIcon-root {
    width: 40px;
    height: 40px;
      color: #004b76;
  }

  &.MuiAccordionSummary-root.Mui-expanded {
    background-color: ${Colors.Primary};
  }

  &:hover {
    background-color: ${Colors.Primary};
  }

  transition: background-color 0.3s;
`

// 詳細エリア
const StyledExpansionPanelDetails = styled(AccordionDetails)`
  &.MuiAccordionDetails-root {
    padding: 15px
  }

  &, .MuiTypography-body1 {
    font-size: ${FontSize.Body};
    word-break: break-all;
      margin-top: 7px;
      margin-left: -1px;
  }
`

// テキストフォント
const StyledTypography = styled(Typography)`
  &.MuiTypography-body1 {
    font-size: ${FontSize.Body};
  }
`
